var mmt,
	MainMenuTabbing = {
		settings: {
			mainMenuClass: ".main-menu",
			menuItemClass: ".menu-item",
			subMenuClass: ".sub-menu",
		},

		init: function () {
			mmt = this.settings;
			this.bindUIActions();
			console.log("MainMenuTabbing functionality loaded!");
		},

		bindUIActions: function () {
			// On window load or resize
			$(window).on("load resize", function () {
				// Remove any injected styles into sub-menu elements
				$(
					`${MainMenuTabbing.settings.mainMenuClass} > ${MainMenuTabbing.settings.menuItemClass} > ${MainMenuTabbing.settings.subMenuClass}`
				).attr("style", "");

				if ($(window).width() >= 1201) {
					$(".expand-submenu-button").removeClass("expanded").blur();
				}
			});

			$(window).on("load", function () {
				// If a menu item has children (or a sub-menu), inject an "expansion arrow" for accessibility after the link in the menu item's link.
				$(".menu-item-has-children > a").each(function () {
					var menuText = $(this).text();
					var menuId =
						"submenu-" +
						menuText
							.replace(/[^a-z0-9\s-]/gi, "")
							.trim()
							.replace(/\s+/g, "-")
							.toLowerCase();
					$(this).next().attr("id", menuId);
					$(this).after(
						'<button class="expand-submenu-button" aria-label="' +
							menuText +
							' Menu" aria-controls="' +
							menuId +
							'" aria-expanded="false"><i class="far fa-chevron-up"></i></button>'
					);
				});
			});

			// When interacted with (clicked)
			$(document).on("click", ".expand-submenu-button", function (event) {
				event.preventDefault();
				// The expand button that was clicked will take on a new class of expanded and will open the sub-menu (via css).
				if ($(this).hasClass("expanded")) {
					$(this).removeClass("expanded");
					$(this).attr("aria-expanded", "false");
				} else {
					$(".expand-submenu-button").removeClass("expanded");
					$(this).toggleClass("expanded");
					$(this).attr("aria-expanded", "true");
				}
			});

			// When interacted with (key pressed)
			$(document).on(
				"keydown",
				".expand-submenu-button.expanded",
				function (event) {
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							$(this)
								.parents(MainMenuTabbing.settings.mainMenuClass)
								.find(".expand-submenu-button.expanded")
								.toggleClass("expanded");
						}
					}
				}
			);

			// When the last menu item is focused and the tab key is pressed, it should close the menu.
			$(document).on(
				"keydown",
				".sub-menu .menu-item:last-child",
				function (event) {
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							// Do nothing.
						} else {
							// Prevent the default behavior.
							event.preventDefault();
							// Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
							$(this)
								.parents(MainMenuTabbing.settings.mainMenuClass)
								.find(".expand-submenu-button.expanded")
								.toggleClass("expanded");
						}
					}
				}
			);

			// When the first menu item is focused and the shift and tab keys are pressed together, it should close the menu.
			$(document).on(
				"keydown",
				".sub-menu .menu-item:first-child",
				function (event) {
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							// Prevent the default behavior.
							event.preventDefault();
							// Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
							$(this)
								.parents(MainMenuTabbing.settings.mainMenuClass)
								.find(".expand-submenu-button.expanded")
								.toggleClass("expanded");
						}
					}
				}
			);
		},
	};

module.exports = MainMenuTabbing;
